import * as O from 'fp-ts/lib/Option'
import { constUndefined, pipe } from 'fp-ts/lib/function'
import { type MutableRefObject, useEffect } from 'react'

export function useOnClickOutside(
  callback: () => void,
  ref: MutableRefObject<HTMLElement | null>,
  documentWrapperId = ''
) {
  useEffect(() => {
    const isAIChatButtonClick = (target: EventTarget | null): boolean => {
      return (
        target instanceof Element &&
        Boolean(target.closest('[aria-label="Chat with our AI assistant"]'))
      )
    }

    function handler(event: Event) {
      // Don't trigger callback if clicking on AI Chat Button
      if (isAIChatButtonClick(event.target)) {
        return
      }

      ref.current &&
        event.target instanceof Node &&
        !ref.current.contains(event.target) &&
        callback()
    }

    return pipe(
      globalThis.document,
      O.fromNullable,
      O.chain(doc =>
        O.fromNullable(
          documentWrapperId ? doc.getElementById(documentWrapperId) : doc
        )
      ),
      O.match(constUndefined, appWrapper => {
        appWrapper.addEventListener('mousedown', handler)
        appWrapper.addEventListener('touchstart', handler)
        return () => {
          appWrapper.removeEventListener('mousedown', handler)
          appWrapper.removeEventListener('touchstart', handler)
        }
      })
    )
  }, [callback, documentWrapperId, ref])
}
